import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './ProjectPreview.css';

const ProjectPreview = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    // Funzione per normalizzare i titoli
    const normalizeTitle = (title) => {
        if (!title) return '';
        return title.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    };

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                // Chiamata API con limite alto per ottenere tutti i progetti
                const apiUrl = process.env.REACT_APP_API_URL || 'https://cogeis.onrender.com';
                const response = await axios.get(`${apiUrl}/api/projects?limit=50&lang=${i18n.language}`);
                const allProjects = response.data.data;
                
                // Array con i 4 progetti specifici richiesti (in entrambe le lingue)
                const requiredProjects = [
                    "FONTANA 27",
                    "Culti Bari", 
                    "Casa Galderisi",
                    "Galderisi House",
                    "Posillipo"
                ];
                
                // Filtra solo i 4 progetti richiesti
                const selectedProjects = allProjects.filter(project => {
                    const projectTitle = project.title || project.titolo;
                    return requiredProjects.includes(projectTitle);
                });
                
                setProjects(selectedProjects);
                setLoading(false);
            } catch (err) {
                console.error('Errore nel caricamento dei progetti:', err);
                setError('Errore nel caricamento dei progetti');
                setLoading(false);
            }
        };

        fetchProjects();
    }, [i18n.language]);

    const handleProjectClick = (projectId) => {
        // Naviga alla pagina Projects con l'ID del progetto come parametro
        navigate(`/progetti?project=${projectId}`);
    };

    if (loading) return <div className="loading">Caricamento progetti...</div>;
    if (error) return <div className="error">{error}</div>;

    return (
        <div className="project-preview-container">
            <div className="projects-vertical-grid">
                {projects.map((project) => (
                    <div 
                        key={project._id} 
                        className="project-card-large"
                        onClick={() => handleProjectClick(project._id)}
                    >
                        <div className="project-image-large">
                            <img 
                                src={(project.images && project.images[0]) || (project.immagine ? [project.immagine][0] : '/default-project.jpg')} 
                                alt={project.title || project.titolo}
                            />
                        </div>
                        <h3>{normalizeTitle(project.title || project.titolo)}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProjectPreview; 